import { render, staticRenderFns } from "./PredictionsWidget.vue?vue&type=template&id=6c67b0dc&scoped=true"
import script from "./PredictionsWidget.vue?vue&type=script&lang=js"
export * from "./PredictionsWidget.vue?vue&type=script&lang=js"
import style0 from "./PredictionsWidget.vue?vue&type=style&index=0&id=6c67b0dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c67b0dc",
  null
  
)

export default component.exports